let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("25r0L")).then(() => parcelRequire('8GUOz'));